module.exports = __webpack_public_path__ + "static/bothPosters-97106eb817c313905fa8f76a74c175fb.png";